import gql from "graphql-tag";

export default gql`
  mutation checkSourceStatus($sourceId: ID) {
    checkSourceStatus(sourceId: $sourceId) {
      id
      use
      disabled
      iaDisabled
      type
      brand
      privacyActivated
      owner
      description
      deploymentNeeds
      firmwareUpdateAvailable
      currentFirmware
      serial
      model
      lastStatus
      lastThumbnail
      thumbnail
      lastStatusOk
      lastStatusKo
      lastChecked
      firstSeen
      publicInterface {
        adminUrl
        streamTcpUrl
      }
      deploymentId
      deployment {
        id
        codename
      }
      firstActiveEventRelated {
        id
        title
      }
    }
  }
`;
